<h3 mat-dialog-title>Seçili İzinler Reddedilecektir,</h3>
<div mat-dialog-content>
    <p>Emin misiniz?</p>
</div>
<textarea style="height: 150px;resize: none;width: 300px;margin-bottom: 10px;
              font-size: 11px;border: 1px solid #9c9c9c;padding: 4px;border-radius: 3px;"
          matInput id="description" aria-describedby="description" placeholder="Açıklama">
    </textarea>
<div mat-dialog-actions="">
    <div style="display: flex;justify-content: left;padding-top: 10px;padding-bottom: 10px;">
        <div mat-dialog-actions align="end">
            <button mat-button (click)="cancelSelected()">Evet</button>
            <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Kapat</button>
        </div>
</div>
</div>
